const openNavMenu = document.querySelector('.open-nav-menu');
const closeNavMenu = document.querySelector('.close-nav-menu');
const navMenu = document.querySelector('.navigation_1_nav');
const navOverlay = document.querySelector('.nav-body-overlay');

openNavMenu.addEventListener("click", toggleNav);
closeNavMenu.addEventListener("click", toggleNav);
navOverlay.addEventListener("click", toggleNav);

function toggleNav() {
    navMenu.classList.toggle("open");
    navOverlay.classList.toggle('active');
    document.body.classList.toggle("hidden-scrolling");
}